module.exports = __webpack_public_path__ + "static/media/3.688e9125.png";